import { render, staticRenderFns } from "./FilterComponent.vue?vue&type=template&id=2aa36e6c&scoped=true"
import script from "./FilterComponent.vue?vue&type=script&lang=js"
export * from "./FilterComponent.vue?vue&type=script&lang=js"
import style0 from "./FilterComponent.vue?vue&type=style&index=0&id=2aa36e6c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aa36e6c",
  null
  
)

export default component.exports